import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/technology",
      name: "Technology",
      component: () => import("@/views/technology/index")
    },
    {
      path: "/enterprise",
      name: "Enterprise",
      component: () =>import("@/views/enterprise/index.vue")
    },
    {
      path: "/intellectual",
      name: "Intellectual",
      component: () =>
        import("@/views/intellectual/index.vue")
    },
    {
      path: "/cognizance",
      name: "Cognizance",
      component: () =>
        import("@/views/cognizance/index.vue")
    },
    {
      path: "/compliance",
      name: "Compliance",
      component: () =>
        import("@/views/compliance/index.vue")
    },
    {
      path: "/support",
      name: "Support",
      component: () =>
        import("@/views/support/index.vue")
    },
    {
      path: "/news",
      name: "news",
      component: () =>
        import("@/views/news/news.vue"),
        
    },
    {
          path:'/news/detail/:id',
          name:'detail',
          component:
          ()=>import("@/views/news/detail")
        
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import("@/views/about.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import("@/views/contact.vue")
    },
    // admin
    {
      path: '/admin/login',
      component: () => import('@/views/admin/login/index'),
      hidden: true
    },

    {
      path: '/admin/news/index',
      component: () => import('@/views/admin/news/index'),
      meta: { title: '新闻列表', icon: 'dashboard' }
    },

    {
      path: '/admin/news/add',
      component: () => import('@/views/admin/news/add'),
      meta: { title: '发布新闻', icon: 'form' }
    },
    {
      path: '/admin/news/apply',
      component: () => import('@/views/admin/news/apply'),
      meta: { title: '客户申请', icon: 'form' }
    },
    {
      path: '/admin/news/edit/:id',
      component: () => import('@/views/admin/news/edit'),
      name: "Edit",
      meta: { title: '编辑', icon: 'form' }
    },
  ],
  mode:'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js